import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/* istanbul ignore file: this file does not contain any logic, only factory calls */
import { createRequestFactory, createLocalizationFactory } from "@tatum/utils";
import { RootStore } from "../store";

var UtilsFactory = /*#__PURE__*/function () {
  function UtilsFactory() {
    _classCallCheck(this, UtilsFactory);

    this.requestMemo = void 0;
    this.localizationMemo = void 0;
  }

  _createClass(UtilsFactory, [{
    key: "request",
    // Create REST API relevant stuff from factory
    get: function get() {
      return this.requestMemo ? this.requestMemo : this.requestMemo = createRequestFactory(RootStore.get.optionStore);
    } // Create i18n relevant stuff from factory

  }, {
    key: "localization",
    get: function get() {
      return this.localizationMemo ? this.localizationMemo : this.localizationMemo = createLocalizationFactory(RootStore.get.optionStore.pureSlug);
    }
  }], [{
    key: "get",
    get: function get() {
      return UtilsFactory.me ? UtilsFactory.me : UtilsFactory.me = new UtilsFactory();
    }
  }]);

  return UtilsFactory;
}();

UtilsFactory.me = void 0;

var urlBuilder = function urlBuilder() {
  var _UtilsFactory$get$req;

  return (_UtilsFactory$get$req = UtilsFactory.get.request).urlBuilder.apply(_UtilsFactory$get$req, arguments);
};

var request = function request() {
  var _UtilsFactory$get$req2;

  return (_UtilsFactory$get$req2 = UtilsFactory.get.request).request.apply(_UtilsFactory$get$req2, arguments);
};

var _n = function _n() {
  var _UtilsFactory$get$loc;

  return (_UtilsFactory$get$loc = UtilsFactory.get.localization)._n.apply(_UtilsFactory$get$loc, arguments);
};

var _nx = function _nx() {
  var _UtilsFactory$get$loc2;

  return (_UtilsFactory$get$loc2 = UtilsFactory.get.localization)._nx.apply(_UtilsFactory$get$loc2, arguments);
};

var _x = function _x() {
  var _UtilsFactory$get$loc3;

  return (_UtilsFactory$get$loc3 = UtilsFactory.get.localization)._x.apply(_UtilsFactory$get$loc3, arguments);
};

var __ = function __() {
  var _UtilsFactory$get$loc4;

  return (_UtilsFactory$get$loc4 = UtilsFactory.get.localization).__.apply(_UtilsFactory$get$loc4, arguments);
};

var _i = function _i() {
  var _UtilsFactory$get$loc5;

  return (_UtilsFactory$get$loc5 = UtilsFactory.get.localization)._i.apply(_UtilsFactory$get$loc5, arguments);
};

export { urlBuilder, request, _n, _nx, _x, __, _i };